import {useCallback, useMemo} from 'react'

import {Field} from 'react-final-form'
import {FieldArray} from 'react-final-form-arrays'
import {useTranslation} from 'react-i18next'

import BaseButton from '../../../../../../Components/Common/Buttons/BaseButton'
import SelectInput from '../../../../../../Components/Common/Inputs/SelectInput/SelectInput'
import {ProductTranslationLanguages} from '../../../../../../infra/constants/ProductTranslationLanguages'
import SEORow from './SEORow'

const SEO = () => {
  const {t} = useTranslation()

  return (
    <FieldArray name="propertiesSection.seo">
      {({fields}) => {
        const availableLanguages = useMemo(() => {
          const usedLanguageIds = fields?.value?.map(field => field.languageId)
          return ProductTranslationLanguages.filter(
            lang => !usedLanguageIds?.includes(lang.languageId)
          )
        }, [fields.value])

        const onRemove = useCallback(
          index => {
            fields.remove(index)
          },
          [fields]
        )

        const onAddSeo = useCallback(
          selectedValue => {
            const selectedLang = ProductTranslationLanguages.find(
              lang => lang.languageId === selectedValue
            )
            if (selectedLang) {
              fields.push({
                languageId: selectedLang.languageId,
                metaTitle: '',
                metaDescription: ''
              })
            }
          },
          [fields]
        )

        const showHeader = fields.length > 0

        return (
          <div className="overflow-auto">
            <table>
              <thead>
                <tr>
                  <th className="heading_4">{showHeader && t('LANGUAGE')}</th>
                  <th className="heading_4">{showHeader && t('META_TITLE')}</th>
                  <th className="heading_4">
                    {showHeader && t('META_DESCRIPTION')}
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {fields &&
                  fields.map((seo, index) => (
                    <SEORow
                      key={seo}
                      name={seo}
                      index={index}
                      onRemove={() => onRemove(index)}
                    />
                  ))}
                <tr>
                  <td>
                    <div className="me-4 table-row-width">
                      <Field name="selectedSEOLanguage" component="select">
                        {({input}) => (
                          <SelectInput
                            {...input}
                            placeholder={t('SELECT_LANGUAGE')}
                            options={availableLanguages}
                            dataKey="languageId"
                            disabled={availableLanguages.length === 0}
                          />
                        )}
                      </Field>
                    </div>
                  </td>
                  <td>
                    <Field name="selectedSEOLanguage">
                      {({input}) => {
                        return (
                          <BaseButton
                            disabled={!input.value}
                            onClick={() => {
                              onAddSeo(input.value)
                              input.onChange('')
                            }}
                            text={t('ADD_SEO')}
                          />
                        )
                      }}
                    </Field>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )
      }}
    </FieldArray>
  )
}

export default SEO
